<form [formGroup]="formIncident" (ngSubmit)="onSubmit()" novalidate >
        
<mat-tab-group mat-stretch-tabs  animationDuration="0ms">
    <mat-tab  label="{{'GENERAL_ADJUSTMENTS_LABEL' | translate}}">
       
       <div class="divForm"> 

        <div class="row">
          <div class="column">
            <mat-label>{{'CATEGORY_LABEL' | translate}}</mat-label>
            <mat-form-field fxFlex="50" appearance="outline">
              
              <mat-select formControlName="categoryId">
                
                <mat-option *ngFor="let option of arrayCategorias" [value]="option.id">{{option.name}}</mat-option>
               
              </mat-select>
            </mat-form-field>
          </div>

          <div class="column">
           <mat-label>{{'ROOT_CAUSE_LABEL' | translate}}</mat-label>
                    <mat-form-field appearance="outline" color="white" class="matformSelect">
                        
                        <mat-select formControlName="rootCauseId">
                          
                          <mat-option *ngFor="let option of arrayCausaRaiz" [value]="option.id">{{option.name}}</mat-option>
                         
                        </mat-select>
                      </mat-form-field>
          </div>

        </div>

        <div class="row">
          <div class="column">
            <mat-label>{{'DESCRIPTION_INCIDENT_FORM' | translate}}</mat-label>
            <mat-form-field class="full-width" appearance="outline">
              
              <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
          

          </div>
          <div class="column">
            <mat-label>{{'ADDRESS_INCIDENT_FORM' | translate}}</mat-label>
           
            <mat-form-field fxFlex="50"  appearance="outline">
    
                <input formControlName="address" matInput readonly="true">
                
            </mat-form-field>
          </div>
        </div>
        
        <div class="row">

                  
          
          <div class="column">
            
            <mat-label>{{'INVOICE_INCIDENT_FORM' | translate}}</mat-label>
           
            <mat-form-field fxFlex="50"  appearance="outline">
    
                <input formControlName="invoice" matInput>
                
                  <!--<button *ngIf="folio" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                    <mat-icon>close</mat-icon>
                  </button>-->
                <div [hidden]="folio.valid || folio.pristine">
                 
                </div>
              </mat-form-field>
          </div>


         
          <div class="column">
            <mat-label>{{'INCIDENT_STATUS_FORM' | translate}}</mat-label>
            <mat-form-field fxFlex="50"  appearance="outline">
    
              <input readonly="true" formControlName="statusincident" matInput>
              
                           
            </mat-form-field>
          </div>
        </div>


        <div class="row">
          <div class="column">
            <mat-label>{{'EVIDENCE_STATUS_FORM_INCIDENT' | translate}}</mat-label>
            <mat-form-field appearance="outline" color="white" class="matformSelect">
                
                <mat-select formControlName="evidenceStatusId">
                  
                  <mat-option *ngFor="let option of arrayEvidenceStatus" [value]="option.id">{{option.name}}</mat-option>
                 
                </mat-select>
              </mat-form-field>
          </div>
          <div class="column">
            <mat-label>{{'REGISTRATION_DATE_LABEL' | translate}}</mat-label>
                    <mat-form-field class="example-full-width" appearance="outline">
                       
                        <input matInput  type="date" formControlName="registrationDate">
                        
                       
                      </mat-form-field>
          </div>
        </div>

        <div class="row">
          
          <div class="column">
           
          </div>
          <div class="column">
            


          </div>

          
        </div>

      

        <div class="row">
          <div class="column">
            <mat-label>{{'DEADLINE_LABEL' | translate}}</mat-label>
                  <mat-form-field  appearance="outline">
                      <input matInput  type="date" formControlName="closingDate">
                  </mat-form-field>
          </div>
          <div class="column">

          </div>

        </div>

        
        
     
      
    </div>
       

    </mat-tab>
    <mat-tab label="{{'PROFILES_LABEL' | translate}}">
        <div class="divForm">

         
          
            <div class="rowTwoColumns">
               
                <div class="column">
                  <mat-label>{{'PERSON_NAME_LABEL' | translate}}</mat-label>
                    <mat-form-field appearance="outline">
        
                        <input type="text" formControlName="personName" matInput placeholder="nombre">
                        
                          <button *ngIf="nombre" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                            <mat-icon>close</mat-icon>
                          </button>
                        
                      </mat-form-field>
                  
                </div>

              
                <div class="column">
                  <mat-label>{{'POSITION' | translate}}</mat-label>
                  <mat-form-field appearance="outline" color="white" class="matformSelect">
                    
                    <mat-select formControlName="positionId">
                      
                      <mat-option *ngFor="let option of arrayPuesto" [value]="option.id">{{option.name}}</mat-option>
                     
                    </mat-select>
                  </mat-form-field>
                    
                </div>
            </div>


            <div class="rowTwoColumns" >
            
                <div class="column">
                  <mat-label>{{'NUMBER_EMPLOYEE' | translate}}</mat-label>
           
                  <mat-form-field fxFlex="50"  appearance="outline">
          
                      <input formControlName="employeeNumber" matInput>
                      
                      
                      <div [hidden]="folio.valid || folio.pristine">
                       
                      </div>
                    </mat-form-field>
                 
                </div>

                
                <div class="column">
                  <mat-label>{{'STAFF_LABEL' | translate}}</mat-label>
                    <mat-form-field appearance="outline" color="white" class="matformSelect">
                        
                        <mat-select formControlName="typeOfStaffId">
                          
                          <mat-option *ngFor="let option of arrayTipoPersonal" [value]="option.id">{{option.name}}</mat-option>
                         
                        </mat-select>
                      </mat-form-field>
                </div>
            </div>

            <div class="rowTwoColumns">
                
                <div class="column">
                  <mat-label>{{'CONSEUQENCES_LABEL' | translate}}</mat-label>
                    <mat-form-field appearance="outline" color="white" class="matformSelect">
                      
                        <mat-select formControlName="consequencesSystemId">
                         
                          <mat-option *ngFor="let option of arraySistemaConsecuencias" [value]="option.id">{{option.name}}</mat-option>
                         
                        </mat-select>
                      </mat-form-field>
                    
                </div>

                
                <div class="column">
                  <mat-label>{{'MONITORIN_ADVISOR_LABEL' | translate}}</mat-label>  
            <mat-form-field  class="margin-right"  appearance="outline">
              
              <input readonly="true" formControlName="monitoringAdvisor"   matInput >
              <div [hidden]="monitoreoAsesor.valid || monitoreoAsesor.pristine">
                 
              </div>
            </mat-form-field>
                  
              </div>
            </div>

            <div class="rowTwoColumns">
               
            <div class="column">
              <mat-label>{{'SITE_LABEL' | translate}}</mat-label>
                    <mat-form-field appearance="outline" color="white" class="matformSelect">
                        
                        <mat-select formControlName="siteId">
                          
                          <mat-option *ngFor="let option of arraySites" [value]="option.id">{{option.name}}</mat-option>
                         
                        </mat-select>
                      </mat-form-field>
             
                </div>
                <div class="column">
                  <mat-label>{{'HEAD_UN' | translate}}</mat-label>
                  <mat-form-field appearance="outline">
      
                      <input type="text" readonly="true" formControlName="headUN" matInput>
                      
                        <button *ngIf="nombre" matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
                          <mat-icon>close</mat-icon>
                        </button>
                      
                    </mat-form-field>
                </div>
             
                
            </div>
        </div>
     

    </mat-tab>
    
 
  </mat-tab-group>

</form>
